import { type HttpClient } from '../useHttpClient';

export const postLlmInsightsForUnit =
  (httpClient: HttpClient) => async (unitId: string, fileUrls: string[]) => {
    await httpClient.api(`/kpis/unit/${unitId}/insights/llm`, {
      method: 'POST',
      body: JSON.stringify({ fileUrls }),
    });
  };
